export default __webpack_public_path__ + "static/media/generalsecretary-icon.998c136b.svg";